<template>
  <div class="outer">
    <div class="middle">
      <div class="center">
        <div class="frame videobackground" style="position: relative;">
          <video
            ref="videoPlayer"
            id="videoPlayer"
            autoplay
            class="videoPlayer"
            @ended="onEnd"
            @contextmenu.prevent
          >
            >
            <source
              :src="
                this.videoData[$parent.videoPath][$parent.chosenLanguage][
                  this.video
                ]
              "
              type="video/mp4"
            />
            <track
              ref="subtitleTrack"
              :src="
                this.videoData[$parent.videoPath][$parent.chosenLanguage][
                  this.video + 'Subs'
                ]
              "
              kind="subtitles"
              srclang="en"
              label="English"
              default
            />
          </video>
          <div class="video-controls">
            <button @click="togglePlayPause" class="control-button">
              {{ isPaused ? '▶' : '⏸' }}
            </button>
            <button @click="toggleSubtitles" class="control-button">
              {{ subtitlesEnabled ? 'CC' : 'CC' }}
              <span :class="{ 'subtitle-off': !subtitlesEnabled }"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@import "../assets/form.css";

.video-controls {
  position: absolute;
  bottom: 20px;
  right: 20px;
  display: flex;
  gap: 10px;
  z-index: 100;
}

.control-button {
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  padding: 10px 15px;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: bold;
  position: relative;
}

.control-button:hover {
  background-color: rgba(0, 0, 0, 0.9);
  border-color: white;
  transform: scale(1.05);
}

.subtitle-off::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  width: 100%;
  height: 2px;
  background-color: red;
}
</style>

<script>
import axios from "axios";

export default {
  name: "videoPlayer",
  props: {
    msg: String,
    dbid: String,
    videoData: Object,
    video: String,
  },
  async mounted() {
    this.$emit("pauseTimer", 1);

    var player = document.getElementById("videoPlayer");
    // setTimeout(() => { this.GameMove() }, this.videoData[this.$parent.videoPath][this.$parent.chosenLanguage][this.video+'Time']);
  },
  data() {
    return {
      teamName: "",
      isPaused: false,
      subtitlesEnabled: true,
    };
  },
  watch: {
    video() {
      this.$nextTick(() => {
        const video = this.$refs.videoPlayer;
        if (video) {
          // Hide all text tracks before loading
          for (let i = 0; i < video.textTracks.length; i++) {
            video.textTracks[i].mode = 'disabled';
          }
          video.load();
          video.play();
          this.isPaused = false;
          // Re-enable subtitles after load if they were enabled
          if (this.subtitlesEnabled) {
            video.addEventListener('loadedmetadata', () => {
              if (video.textTracks.length > 0) {
                video.textTracks[0].mode = 'showing';
              }
            }, { once: true });
          }
        }
      });
    },
  },
  methods: {
    GameMove() {
      this.$emit("pauseTimer", 0);
      this.$emit("updatestage", "");
    },
    onEnd() {
      setTimeout(() => {
        this.GameMove();
      }, 2);
    },
    togglePlayPause() {
      const video = this.$refs.videoPlayer;
      if (video.paused) {
        video.play();
        this.isPaused = false;
      } else {
        video.pause();
        this.isPaused = true;
      }
    },
    toggleSubtitles() {
      const video = this.$refs.videoPlayer;
      const tracks = video.textTracks;

      if (tracks.length > 0) {
        if (this.subtitlesEnabled) {
          tracks[0].mode = 'hidden';
          this.subtitlesEnabled = false;
        } else {
          tracks[0].mode = 'showing';
          this.subtitlesEnabled = true;
        }
      }
    },
  },
};
</script>


